var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTweetIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.307 15.988a236.16 236.16 0 00-2.551 2.626c-2.431 2.527-4.986 5.183-7.7 7.44C24.25 29.217 20.24 31.5 16 31.5 7.44 31.5.5 24.56.5 16 .5 7.44 7.44.5 16 .5c4.247 0 8.26 2.165 12.06 5.263 3.29 2.681 6.363 6.014 9.246 9.141l1 1.084z",
    fill: "#1DA1F2",
    stroke: "#1DA1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 11.539a6.54 6.54 0 01-1.885.516 3.288 3.288 0 001.444-1.815 6.564 6.564 0 01-2.086.796 3.282 3.282 0 00-5.592 2.993 9.317 9.317 0 01-6.767-3.43 3.277 3.277 0 00-.444 1.652 3.28 3.28 0 001.46 2.731 3.286 3.286 0 01-1.488-.41v.041a3.283 3.283 0 002.635 3.218 3.268 3.268 0 01-1.483.057 3.284 3.284 0 003.066 2.278 6.586 6.586 0 01-4.077 1.406c-.265 0-.527-.015-.783-.045A9.308 9.308 0 0013.032 23c6.038 0 9.34-5 9.34-9.337 0-.143-.003-.286-.009-.425A6.643 6.643 0 0024 11.539z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweetIcon);
export default "/_next/static/images/44ead644c7e54312afbe05acfcde038c.svg";
export { ForwardRef as ReactComponent };